import React from 'react';
import type { CaseStatus } from '../../types/admin';
const tones: Record<CaseStatus, string> = {
  'Ny henvendelse': 'border-transparent bg-accent text-white',
  'Kontaktet': 'border-line bg-canvas-deep text-ink-soft',
  'Tilbud sendt': 'border-status-warn/35 bg-status-warn/10 text-status-warn',
  'Accepteret': 'border-accent/35 bg-accent/10 text-accent-deep',
  'Planlagt': 'border-status-info/35 bg-status-info/10 text-status-info',
  'I gang': 'border-status-ok/40 bg-status-ok/15 text-status-ok',
  'Færdig': 'border-status-ok/30 bg-transparent text-status-ok',
  'Faktureret': 'border-line bg-canvas-deep text-ink-muted'
};
export function StatusBadge({
  status,
  className = ''
}: {
  status: CaseStatus;
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border px-2.5 py-1 text-xs font-medium ${tones[status]} ${className}`} data-id="element-458" data-mp="1f0l9plh32put">
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" aria-hidden="true" data-id="element-459" data-mp="mhxswi94dwzj" />
      {status}
    </span>;
}